import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { DiversificationCompany, DiversificationCompanyUnits as Units, SvgIconId } from 'client/bundles/types';
import Help from 'client/components/help';
import SvgIcon from 'client/components/svg-icon';
import WideStripe from 'client/components/wide-stripe';

import './index.css';

const b = cn('compare-company');

interface Props {
    company: DiversificationCompany[];
    dictionary: Record<Units, string>;
}

const ROWS = [
    Units.Search,
    Units.Advertising,
    Units.Maps,
    Units.Ridetech,
    Units.Foodtech,
    Units.Ecom,
    Units.Cloud,
    Units.Media,
    Units.Drones,
    Units.Financetech
];

const ICONS: Record<Units, SvgIconId> = {
    [Units.Search]: 'button-hand',
    [Units.Advertising]: 'megafon',
    [Units.Maps]: 'roadmap',
    [Units.Ridetech]: 'taxi',
    [Units.Foodtech]: 'box-mini',
    [Units.Ecom]: 'shopping-cart',
    [Units.Cloud]: 'cloud',
    [Units.Media]: 'star',
    [Units.Drones]: 'steering-wheel',
    [Units.Financetech]: 'coins'
};

class CompareCompany extends Component<Props> {
    render() {
        const { dictionary, company } = this.props;

        return (
            <div className={b()}>
                <WideStripe>
                    <div className={b('wrapper')}>
                        <div className={b('inner')}>
                            <table className={b('table')}>
                                <thead>
                                    <td />
                                    {company.map(({ name, id }) => (
                                        <th key={id} className={b('thead-th')} >
                                            <div className={b('cell')}>
                                                <div className={b('name', { id })}>{name}</div>
                                            </div>
                                        </th>
                                    ))}
                                </thead>
                                <tbody>
                                    {ROWS.map(row => (
                                        <tr key={row}>
                                            <th className={b('tbody-th')}>
                                                <div className={b('cell')}>
                                                    <SvgIcon icon={ICONS[row]} mix={b('icon')} />
                                                    {dictionary[row]}
                                                </div>
                                            </th>
                                            {company.map(item => (
                                                <td key={`${item.id}-${row}`} className={b('tbody-td')}>
                                                    <div className={b('cell')}>
                                                        {item[row].has ?
                                                            <SvgIcon
                                                                icon="compare-true"
                                                                mix={b('has', { false: !item[row].has, help: Boolean(item[row].help) })}
                                                                /> :
                                                            <SvgIcon
                                                                icon="compare-false"
                                                                mix={b('has', { false: !item[row].has, help: Boolean(item[row].help) })}
                                                                />
                                                        }
                                                        {item[row].help && (
                                                            <Help
                                                                content={item[row].help}
                                                                mix={b('help')}
                                                                />
                                                        )}
                                                    </div>
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </WideStripe>
            </div>
        );
    }
}

export default CompareCompany;
